import App from '@/App';
import CardTypePage from '@/pages/custom-menu/card-type/CardTypePage';
import CategoryTypePage from '@/pages/custom-menu/category-type/CategoryTypePage';
import ListTypePage from '@/pages/custom-menu/list-type/ListTypePage';
import ListTypeDetailPage from '@/pages/custom-menu/list-type/Detail/ListTypeDetailPage';
import ToggleTypePage from '@/pages/custom-menu/toggle-type/ToggleTypePage';
import FloorGuidePage from '@/pages/floor-guide/FloorGuidePage';
import HomePage from '@/pages/home/HomePage';
import ShopPage from '@/pages/shop/ShopPage';
import { PATHS } from '@/router/paths';
import type { RouteObject } from 'react-router-dom';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import EventPage from '@/pages/custom-menu/event/eventPage';
import ParkingPage from '@/pages/custom-menu/category-type/parking';

const routes: RouteObject[] = [
    {
        element: <App />,
        children: [
            {
                path: PATHS.INDEX,
                children: [
                    { index: true, element: <Navigate to={PATHS.HOME.INDEX} replace /> },
                    {
                        path: PATHS.HOME.INDEX,
                        children: [{ index: true, element: <HomePage />, handle: { fullWidth: true } }],
                    },
                    {
                        path: PATHS.FLOOR_GUIDE.INDEX,
                        children: [{ index: true, element: <FloorGuidePage /> }],
                    },
                    {
                        path: PATHS.SHOP.INDEX,
                        children: [{ index: true, element: <ShopPage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.LIST_TYPE,
                        children: [{ index: true, element: <ListTypePage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.LIST_TYPE}/:gnbMenuId/detail/:id`,
                        children: [{ index: true, element: <ListTypeDetailPage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.LIST_TYPE}/:gnbMenuId`,
                        children: [{ index: true, element: <ListTypePage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.CARD_TYPE,
                        children: [{ index: true, element: <CardTypePage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.CARD_TYPE}/:gnbMenuId`,
                        children: [{ index: true, element: <CardTypePage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.TOGGLE_TYPE,
                        children: [{ index: true, element: <ToggleTypePage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.TOGGLE_TYPE}/:gnbMenuId`,
                        children: [{ index: true, element: <ToggleTypePage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.CATEGORY_TYPE,
                        children: [{ index: true, element: <CategoryTypePage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.CATEGORY_TYPE}/:gnbMenuId`,
                        children: [{ index: true, element: <CategoryTypePage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.EVENT,
                        children: [{ index: true, element: <EventPage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.EVENT}/:gnbMenuId`,
                        children: [{ index: true, element: <EventPage /> }],
                    },
                    {
                        path: PATHS.CUSTOM_MENU.PARKING,
                        children: [{ index: true, element: <ParkingPage /> }],
                    },
                    {
                        path: `${PATHS.CUSTOM_MENU.PARKING}/:gnbMenuId`,
                        children: [{ index: true, element: <ParkingPage /> }],
                    },
                ],
            },
            { path: '*', element: <Navigate to={PATHS.HOME.INDEX} replace /> },
        ],
    },
];

export const router = createBrowserRouter(routes);
export default routes;
